import { render } from "./WebsiteGallery.vue?vue&type=template&id=03fd38a4&scoped=true"
import script from "./WebsiteGallery.vue?vue&type=script&lang=js"
export * from "./WebsiteGallery.vue?vue&type=script&lang=js"

import "./WebsiteGallery.vue?vue&type=style&index=0&id=03fd38a4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fd38a4"]])

export default __exports__